/**
 * Meta (Facebook) Pixel — env-gated. No-ops entirely until REACT_APP_META_PIXEL_ID
 * is set, so this ships inert in production until a pixel ID is provided.
 */

let initialized = false;

function loadMetaPixelScript(pixelId) {
  if (typeof window === "undefined") return;
  if (window.fbq) return;
  if (document.querySelector('script[src*="connect.facebook.net"]')) return;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

export function initMetaPixel() {
  if (initialized) return;
  const pixelId = String(process.env.REACT_APP_META_PIXEL_ID || "").trim();
  if (!pixelId) {
    if (process.env.NODE_ENV === "development") {
      console.debug("[metaPixel] REACT_APP_META_PIXEL_ID not set — pixel disabled");
    }
    return;
  }
  try {
    loadMetaPixelScript(pixelId);
    initialized = true;
  } catch (err) {
    console.warn("[metaPixel] failed to initialize:", err?.message || err);
  }
}

export function trackPixelEvent(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", eventName, params);
    }
  } catch {
    /* tracking must never break the signup flow */
  }
}
